import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Icon } from 'Permafrost/index';
import { StyledShrug } from './Shrug.styles';
export function Shrug(props) {
    const { actionLink, actionText, buttonAction, buttonText, className, id, message } = props;
    return (React.createElement(StyledShrug, { className: className, "data-cy": props['data-cy'], id: id },
        React.createElement(Icon, { name: "shrug", size: ['260px', '84px'] }),
        typeof message === 'string' ? (React.createElement("p", Object.assign({ className: "t-subhead-large" }, props === null || props === void 0 ? void 0 : props.messageProps), message)) : (message),
        actionLink && actionText && (React.createElement(Link, { to: actionLink, className: "button blue cta", style: { marginTop: '20px' } }, actionText)),
        buttonAction && buttonText && (React.createElement(Button, { onClick: buttonAction, style: { marginTop: '20px' }, variant: "cta" }, buttonText))));
}
//# sourceMappingURL=Shrug.js.map